export default __webpack_public_path__ + "static/media/logo.74d91f3f.svg";